import React, {Suspense} from 'react';
import { Route } from 'react-router-dom';

const Articles = React.lazy(() => import('./index'));
const ArticleTable = React.lazy(() => import('./articleTable'));
const Article = React.lazy(() => import('./article'));
const ArticleDetail = React.lazy(() => import('./articleDetail'));
const AddNewArticle = React.lazy(() => import('./addNewArticle'));
const EditArticle = React.lazy(() => import('./editArticle'));
const ArticlePublishReject = React.lazy(() => import('./articlePublishReject'));
const ArticleReviseRequest = React.lazy(() => import('./articleReviseRequest'));
const ArticleReviseReject = React.lazy(() => import('./articleReviseReject'));

export const useArticleRoutes = () => {

    return (
        <Route path="articles" element={<Suspense fallback={<div>منتظر باشید...</div>}><Articles /></Suspense>} >
            <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><ArticleTable/></Suspense> } />
            <Route path="new" element={<Suspense fallback={<div>منتظر باشید...</div>}><AddNewArticle/></Suspense> } />
            <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><Article/></Suspense> } >
                <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><ArticleDetail/></Suspense> } />
                <Route path="edit" element={<Suspense fallback={<div>منتظر باشید...</div>}><EditArticle/></Suspense> } />
                <Route path="publishReject" element={<Suspense fallback={<div>منتظر باشید...</div>}><ArticlePublishReject/></Suspense> } />
                <Route path="reviseRequest" element={<Suspense fallback={<div>منتظر باشید...</div>}><ArticleReviseRequest/></Suspense> } />
                <Route path="reviseReject" element={<Suspense fallback={<div>منتظر باشید...</div>}><ArticleReviseReject/></Suspense> } />
            </Route>
        </Route>
    )
}